import React from 'react'
import { Select, MenuItem } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

const CustomSelect = ({ value, onChange, listValues, fullwidth, defaultVal }) => {
        const isMobile = useSelector(state => state.home.isMobileDev);
    
    return (
        <div
        //  style={{ width: '100%' }}
        >
            <Select
                value={value}
                onChange={onChange}
                sx={{ width: '100%', fontSize: isMobile? 14: 16 }}
                defaultValue={defaultVal}
            >
                {listValues.map((each) => (
                    <MenuItem key={each} value={each} sx={{ fontSize: isMobile? 14: 16 }}>
                        {each}
                    </MenuItem>
                ))}
            </Select>
        </div>
    )
}

export default CustomSelect
